import { getVersionForClone } from '@qr-front/ui/utils'

import { BaseStepper } from './BaseStepper'
import { Clone1Stepper } from './Clone1Stepper'

export const Stepper = getVersionForClone({
	base: BaseStepper,
	clone1: Clone1Stepper,
})
